import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import Seo from './Seo';
import SectionTitle from './SectionTitle';

const Contact = () => {
  const [formData, setFormData] = useState({
    nom: '',
    prenom: '',
    email: '',
    message: ''
  });
  const [message, setMessage] = useState({ text: '', type: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    emailjs.send("service_qkys17b", "template_pif87op", formData, "PLi8th08jjjpSIb-M")
      .then((result) => {
        console.log(result.text);
        setMessage({ text: 'Email envoyé avec succès', type: 'success' });
      }, (error) => {
        console.log(error.text);
        setMessage({ text: 'Erreur lors de l\'envoi de l\'email', type: 'error' });
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <div className="contact-form container mt-5">
      <Seo
        path="/contact"
        title="Contact"
        description="Contactez le Tennis de Table Briançon pour essayer un entraînement, vous renseigner sur les tarifs ou prendre une licence."
      />
      <SectionTitle as="h1" overline="Nous rejoindre">
        Nous contacter
      </SectionTitle>

      <p className="page-intro">
        Une question sur les entraînements, les tarifs ou la licence&nbsp;? Envie
        d'essayer le tennis de table à Briançon&nbsp;? Écrivez-nous avec le
        formulaire ci-dessous ou par e-mail : nous vous répondrons rapidement et
        vous accueillerons avec plaisir à une séance d'essai, sans engagement. Le
        club s'entraîne au Vieux gymnase des Garcins, le mercredi, le vendredi et
        le samedi.
      </p>

      {message.text && (
        <div className={`alert alert-${message.type === 'success' ? 'success' : 'danger'}`}>
          {message.text}
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="nom" className="form-label">Nom:</label>
          <input
            type="text"
            className="form-control"
            id="nom"
            name="nom"
            value={formData.nom}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="prenom" className="form-label">Prénom:</label>
          <input
            type="text"
            className="form-control"
            id="prenom"
            name="prenom"
            value={formData.prenom}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="email" className="form-label">Email:</label>
          <input
            type="email"
            className="form-control"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="message" className="form-label">Message:</label>
          <textarea
            className="form-control"
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
          />
        </div>
        <div className='text-center'>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Envoi en cours...' : 'Envoyer'}
          </button>
        </div>
      </form>
      <p className='mt-5'>
        {'Ou envoyez-nous un email directement à : '}
        <a href="mailto:contact@ttbriancon.fr" className="text-decoration-none">contact@ttbriancon.fr</a>
      </p>
    </div>
  );
};

export default Contact;
